import {defineStore} from 'pinia'
import Vue from "vue";
import {findIndex, isArray, isEmpty, remove} from "lodash";
import MixinGenericFtp from "@/mixins/generic/MixinGenericFtp";
import axios from "axios";


export const useConnectionsStore = defineStore('connections', {
    state: () => {
        return {
            defaultLocal: '[{"key":"local","value":{"server":"","username":"","password":"","type":"local"}}]',
            connections: [{
                key: 'local',
                value: {
                    server: '',
                    username: '',
                    password: '',
                    type: 'local',
                    // -1 not checked, 0 not valid, 1 valid.  Note that local connection by default are expected to have the validity as true.
                    isValid: 1
                }
            }],
            currentConnection: '',
            connectionHistory: [],
            /**
             * Stringified because our getter expects this to be a string to be parsed
             */
            connectionsInitialState: '[{"key":"local","value":{"server":"","username":"","password":"","type":"local", "isValid": true}}]',
            isEnabled: false,
        }
    },
    actions: {

        /**
         *
         * Caller is expected to have the progress bar
         *
         * @param connection
         * @returns {Promise<number>}
         */
        async validateConnectionAndUpdateConnections(connection) {

            let self = this;
            let connectionValidity = -1

            if (connection?.value?.type?.toLowerCase() === 'ftp') {

                let params = {
                    "host": connection.value.server,
                    "username": connection.value.username,
                    "password": connection.value.password,
                };

                try {
                    /*
                    let ftpConnectionResponse = await axios.get('validate_ftp_connection.php', {params});

                    if (ftpConnectionResponse) {
                        connectionValidity = ftpConnectionResponse.data.status ? 1 : 0
                    }
                    */

                    connectionValidity = true;

                } catch (e) {

                }

            }

            return connectionValidity;
        },

        /**
         * setConnections and setConnectionsInitialState should have similar code
         * @param connections
         */
        setConnections(connections) {

            if (typeof connections === 'undefined' || connections === null || connections === '' || !connections || isEmpty(connections)) {
                connections = JSON.parse(this.defaultLocal);
            }

            this.connections = connections
        },
        /**
         * getConnectionsInitialState and getConnections functions should have similar code
         * @returns {any}
         */
        getConnections() {
            return this.connections;
        },
        hasConnections() {
            if (this.connections && this.connections.length > 0) {
                return true;
            }
            return false;
        },
        pickAConnectionFromConnections() {

            let self = this;
            let connection = false;

            if (self.hasConnections()) {

                let connections = self.getConnections();

                let filteredForTypeLocal = connections.filter((p) => {
                    if (p.value && p.value.hasOwnProperty('type')) {
                        return p.value.type === 'local'
                    }
                });

                let localConnection = typeof filteredForTypeLocal === 'object' ? filteredForTypeLocal[0] : false;

                if (!localConnection) {
                    connection = connections[0]
                } else {
                    connection = localConnection;
                }

            }

            if (connection) {
                self.setCurrentConnection(connection);
            }

            return connection;

        },
        hasCurrentConnection() {

            let self = this;
            return (self.currentConnection && self.currentConnection.hasOwnProperty('value') && self.currentConnection.value);

        },
        isAValidConnection(key) {

            if (this.connections && this.connections.length > 0) {
                let connection = this.connections.find((p) => {
                    return p.key === key
                });
                if (connection) {
                    return true;
                }
            }

            return false;
        },
        /**
         * @param connection
         */
        setCurrentConnection(connection) {

            if (connection) {
                this.setConnectionHistory(connection)
                Vue.set(this, 'currentConnection', connection)
            }
        },
        /**
         * @param connection
         */
        setCurrentConnectionWithoutHistory(connection) {

            if (connection) {
                Vue.set(this, 'currentConnection', connection)
            }
        },
        setCurrentConnectionIfCurrentConnectionIsNotSetAlready() {
            if (!this.hasCurrentConnection()) {
                this.pickAConnectionFromConnections();
            }
        },
        getCurrentConnection() {
            return this.currentConnection
        },
        setConnectionHistory(connection) {
            this.connectionHistory.push(connection)
        },
        getConnectionHistory() {
            return this.connectionHistory
        },

        updateConnection(oldValue, newValue) {

            let self = this;

            let index = findIndex(self.connections, function (val, key) {
                return val.key === oldValue.key;
            })

            if (index !== -1) {
                self.connections[index]['key'] = newValue.key;
                self.connections[index]['value'] = newValue.value;

                return true;
            }

            return false;

        },
        updateConnectionHistory(oldValue, newValue) {

            let self = this;

            let index = findIndex(self.connectionHistory, function (val, key) {
                return val.key === oldValue.key;
            })

            if (index !== -1) {
                self.connectionHistory[index]['key'] = newValue.key;
                self.connectionHistory[index]['value'] = newValue.value;

                return true;
            }

            return false;

        },

        getSecondLastElementFromConnectionHistoryIfItExists() {

            let self = this;

            if (self.connectionHistory.length >= 2) {
                return self.connectionHistory[self.connectionHistory.length - 2]
            }

            return false;

        },

        /**
         *
         * @returns {boolean}
         */
        deleteCurrentConnectionAndDeleteItFromConnectionHistory(externalConnectionToDelete = false) {

            let self = this;
            let index;

            if (!externalConnectionToDelete) {
                index = findIndex(self.connections, {key: self.currentConnection.key});
            } else {
                index = findIndex(self.connections, {key: externalConnectionToDelete.key});
            }

            if (index > -1) {

                let elementToDelete = self.connections[index];
                self.connections.splice(index, 1);

                // Do not accept the returned array, those are deleted elements.
                remove(self.connectionHistory, (p) => {
                    return p.key === elementToDelete.key
                });

                return true;

            }

            return false;

        },

        /**
         * The difference is if the last connection is same as the current connection, we will be looking for a previous valid connection
         */
        getPreviousConnectionFromConnectionHistoryIfItExists() {

            let self = this;

            if (isArray(self.connectionHistory) && self.connectionHistory.length >= 1) {

                let allConnectionsExceptForCurrentConnection = self.connectionHistory.filter((p) => {
                    return p.key !== self.currentConnection.key
                });

                return allConnectionsExceptForCurrentConnection[allConnectionsExceptForCurrentConnection.length - 1];

            }

            return false;

        },

        getLastElementFromConnectionHistoryIfItExists() {

            let self = this;

            if (isArray(self.connectionHistory) && self.connectionHistory.length >= 1) {
                return self.connectionHistory[self.connectionHistory.length - 1]
            }

            return false;

        },

        /**
         * getConnectionsInitialState and getConnections functions should have similar code
         */
        getConnectionsInitialState() {
            return this.connectionsInitialState;
        },
        /**
         * setConnections and setConnectionsInitialState should have similar code
         * @param connections
         */
        setConnectionsInitialState(connections) {

            if (typeof connections === 'undefined' || connections === null || connections === '' || !connections || isEmpty(connections)) {
                connections = JSON.parse(this.defaultLocal);
            }

            this.connectionsInitialState = connections
        }

    }

})
